import { Code, Layout, Palette } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const WebDevHero = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center">
      <div className="absolute inset-0 bg-gradient-to-r from-blue-950/95 to-blue-900/95" />
      <div 
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1531297484001-80022131f5a1?q=80')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="text-white space-y-8">
            <h1 className="text-5xl font-bold leading-tight">
              Transform Your Digital Vision Into Reality
            </h1>
            <p className="text-xl text-blue-100 leading-relaxed">
              From stunning designs to powerful functionality, we create websites 
              that captivate your audience and drive business growth. By harnessing the power of AI-driven tools and automation, 
              we design and develop high-performing websites quickly and efficiently, ensuring your business is online, optimized, 
              and ready to scale without delay.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/contact">
                <Button size="lg" className="bg-white text-blue-900 hover:bg-blue-50 w-full sm:w-auto">
                  Start Your Project
                </Button>
              </Link>
              <Link to="/case-studies">
                <Button 
                  size="lg" 
                  variant="secondary"
                  className="bg-blue-100 text-blue-900 hover:bg-blue-200 w-full sm:w-auto"
                >
                  View Our Work
                </Button>
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-6">
            {[
              {
                icon: <Layout className="h-8 w-8 mb-4" />,
                title: "Custom Design",
                description: "Unique, brand-aligned websites that stand out"
              },
              {
                icon: <Code className="h-8 w-8 mb-4" />,
                title: "Development",
                description: "Clean, efficient code for optimal performance"
              },
              {
                icon: <Palette className="h-8 w-8 mb-4" />,
                title: "UI/UX Design",
                description: "Intuitive interfaces that users love"
              },
              {
                icon: <Layout className="h-8 w-8 mb-4" />,
                title: "Responsive",
                description: "Perfect display on all devices"
              }
            ].map((feature, index) => (
              <div 
                key={index}
                className="p-6 rounded-xl bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-colors"
              >
                {feature.icon}
                <h3 className="text-white font-semibold mb-2">{feature.title}</h3>
                <p className="text-blue-100 text-sm">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};